<template>
    <v-list-item-subtitle class="message-preview">
        <v-icon v-if="origin != 'customer'" size="16" :color="status >= 4 ? 'blue' : 'grey lighten-1'" class="mr-1">
            mdi-check-all
        </v-icon>
        <span v-html="renderedMessage"></span>
    </v-list-item-subtitle>
</template>

<script>

export default {
    name: 'MessagePreview',
    props: {
        origin: {
            type: String,
            default: "customer"
        },
        type: {
            type: String,
            default: "text"
        },
        message: {
            type: String,
            default: ""
        },
        status: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            media_types: {
                "image": "Imagem",
                "audio": "Áudio",
                "video": "Vídeo",
                "document": "Documento",
                "contact": "Contato"
            }
        }
    },
    computed: {
        renderedMessage() {
        if (this.type === 'text') return this.$utils.renderBoldText(this.message);
            return this.type ? this.media_types[this.type] : (this.message || '');
        },
  },
}

</script>

<style>
.message-preview {
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
</style>